import * as React from "react";
import {Component } from "react";

import "./header.scss";

import {Search} from "../../../core/components/search/search";
import {UiState} from "../../../core/ui-state";
import {SearchConfiguration} from "../../../core/config/search-configuration";

import {Button, Menu} from "semantic-ui-react";

import {AppState} from "../app-mobx";
import {MapState} from "../../../core/map-state";
import {MessdatenConfiguration} from "../../../config/messdaten-configuration";
import {MapViewerConfiguration} from "../../../config/map-viewer-configuration";
import {Title} from "../../../core/components/title/title";
import {observer} from "mobx-react";
import {MapFinder} from "../../../core/components/map-finder/map-finder";
import {AppConfiguration} from "../../../core/config/app-configuration";
import MediaQuery from "react-responsive";
import {runInAction} from "mobx";
import {TopicSwitcherButton} from "../../../core/components/topic-switcher/topic-switcher-button";
import logo from "../../../assets/images/kt_logo_white_inverted.svg";
import SVG from "react-inlinesvg";

export interface HeaderProps {
    view: __esri.MapView | __esri.SceneView | undefined;
    appStore: AppState;
    uiStore: UiState;
    mapStore: MapState;
    capabilities: string[];
    appConfig: AppConfiguration;
    searchConfig?: SearchConfiguration;  // widgetsSearch is also the type for configuration object
    messdatenConfig: MessdatenConfiguration;
}

@observer
export class Header extends Component<HeaderProps, any> {

    constructor(props: HeaderProps) {
        super(props);
        this.state = {
            search: null
        };
    }
    toggleSidebarVisible(): void {
        runInAction(()=> {
            const {sidebarVisible} = this.props.uiStore;
            this.props.uiStore.setSidebarVisible(!sidebarVisible);
        });
    }
    render(): JSX.Element | null {
        const {appStore, appConfig, mapStore, messdatenConfig, searchConfig, uiStore} = this.props;
        const mapViewerConfig = messdatenConfig as MapViewerConfiguration;
        const mode = appConfig.mode;
        const {subtopic} = this.props.appStore;

        if (!subtopic) {
            return null;
        }
        let aboutLink: JSX.Element | undefined;
        const parentTopic = mapViewerConfig?.subtopics.find((t) => subtopic.parentId === t.id);
        return(
            <div className={"geo-app-header"}>
                <Title
                    siteTitle={`${mapViewerConfig.appName} ${parentTopic?.name} (${subtopic.label})`}
                    pageTitle={mapViewerConfig.title} />
                <Menu attached="top" inverted>
                    <div className={"geo-logo"}>
                        <Menu.Item>
                            <a href={"https://geoportal.lu.ch"} target="_blank" rel={"noreferrer"}>
                                <SVG src={logo} height={25} width={84}/>
                                {(mode !== "production")? (
                                    <span className="geo-badge geo-test-badge">Test</span>) : ""}</a>
                        </Menu.Item>
                    </div>
                    <MediaQuery maxWidth={mapViewerConfig.breakpoints.md}>
                        <Menu.Item className={"geo-map-mobile-menu"}>
                            <Button onClick={() => this.toggleSidebarVisible()}>
                                <span className="header__mobilenavigation-button-text">Navigation</span>
                            </Button>
                        </Menu.Item>
                    </MediaQuery>
                    {(mapViewerConfig.subtopics
                        && Array.isArray(mapViewerConfig.topicSwitcher?.visible)
                        && mapViewerConfig.topicSwitcher.visible.includes("header"))?<TopicSwitcherButton
                            appStore={appStore}
                            mapStore={mapStore}
                            uiStore={uiStore}
                            topics={mapViewerConfig.subtopics}
                            mapviewerConfig={mapViewerConfig}
                            showTopic={true}
                        />: <h1><span>{subtopic.label}</span>{aboutLink}</h1>}
                    <Menu.Menu position="right">
                        <MediaQuery minWidth={(mapViewerConfig.breakpoints.md + 1)}>
                            <Menu.Item className={"geo-map-finder"}>
                                <MapFinder
                                    appStore={appStore}
                                    mapViewerConfig={mapViewerConfig}
                                    appConfig={appConfig}
                                    mapStore={mapStore} uiStore={uiStore}/>
                            </Menu.Item>
                        </MediaQuery>
                        {this.props.capabilities.map((cap) => {
                            if (cap === "search" && searchConfig) {
                                return (
                                    <Search
                                        key={cap}
                                        mapStore={mapStore}
                                        uiStore={uiStore}
                                        config={searchConfig}
                                    />
                                );
                            }
                        })}
                    </Menu.Menu>
                </Menu>
            </div>
        );
    }
}
